// removed by extract-text-webpack-plugin
module.exports = {"graphic":"PasswordChange__graphic___1nLBL","lettering":"PasswordChange__lettering___rJ_S8","h3":"PasswordChange__h3___268UK"};


//////////////////
// WEBPACK FOOTER
// ./study_reviewer/src/components/passwordChange/PasswordChange.css
// module id = 1210
// module chunks = 0